module.exports = __webpack_public_path__ + "static/media/instagram.d1d7cc68.svg";